/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t({top:t,left:o,right:n,bottom:r}){return{x:{min:o,max:n},y:{min:t,max:r}}}function o({x:t,y:o}){return{top:o.min,right:t.max,bottom:o.max,left:t.min}}function n(t,o){if(!o)return t;const n=o({x:t.left,y:t.top}),r=o({x:t.right,y:t.bottom});return{top:n.y,left:n.x,bottom:r.y,right:r.x}}export{t as convertBoundingBoxToBox,o as convertBoxToBoundingBox,n as transformBoxPoints};
//# sourceMappingURL=conversion.js.map
